'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'reflect-horizontal';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e664';
var svgPathData = 'M256 32c13.3 0 24 10.7 24 24l0 400c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-400c0-13.3 10.7-24 24-24zM14.8 97.8c9-3.7 19.3-1.7 26.2 5.2L177 239c9.4 9.4 9.4 24.6 0 33.9L41 409c-6.9 6.9-17.2 8.9-26.2 5.2S0 401.7 0 392L0 120c0-9.7 5.8-18.5 14.8-22.2zM471 103c6.9-6.9 17.2-8.9 26.2-5.2S512 110.3 512 120l0 272c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L335 273c-9.4-9.4-9.4-24.6 0-33.9L471 103z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faReflectHorizontal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;